import { formatDateByLanguage } from "./formatDateByLanguage";

export function getTranslatedTitleAndDescriptionNotifications(
  title: string,
  descriptionRaw: string,
  t: (key: string, options?: Record<string, any>) => string
): string {
  if (!title || !descriptionRaw) return "";

  function extractUserInfo(description: string) {
    const match = /User (.+) was registered at (.+) on (.+)/.exec(description);
    return {
      name: match?.[1] || "",
      companyName: match?.[2] || "",
      date: match?.[3] || "",
    };
  }

  function extractCode(description: string) {
    const reportCodeMatch = description.match(/RP-\w+/);

    return { code: reportCodeMatch?.[0] || "" };
  }

  function extractCodeAndAuthor(description: string) {
    const match = description.match(
      /complaint number: ([A-Z0-9]+).*?by (.+)\.?$/
    );
    return { code: match?.[1] || "", author: match?.[2] || "" };
  }

  if (title.includes("New User registered")) {
    const { name, companyName, date } = extractUserInfo(descriptionRaw);
    if (name && companyName && date) {
      const formattedDate = formatDateByLanguage(date);
      return t("newUserRegisteredDescription", {
        name,
        companyName,
        date: formattedDate,
      });
    }
  } else if (title.includes("Draft Triage Report processing was Finished")) {
    const { code } = extractCode(descriptionRaw);
    if (code)
      return t("draftTriageReportProcessingFinishedDescription", {
        code,
      });
  } else if (title.includes("New Message Inbox")) {
    const { code } = extractCode(descriptionRaw);
    if (code) return t("newMessageInboxDescription", { code });
  } else if (title.includes("Closure Complaint Request - Approved")) {
    const { code, author } = extractCodeAndAuthor(descriptionRaw);
    if (code && author)
      return t("closureComplaintRequestApprovedDescription", { code, author });
  } else if (title.includes("Closure Complaint Request - Rejected")) {
    const { code, author } = extractCodeAndAuthor(descriptionRaw);
    if (code && author)
      return t("closureComplaintRequestRejectedDescription", { code, author });
  } else if (title.includes("New Closure Complaint Request")) {
    const { code, author } = extractCodeAndAuthor(descriptionRaw);
    if (code && author)
      return t("newClosureComplaintRequestDescription", {
        reportCode: code,
        author,
      });
  } else if (title.includes("New Complaint Invalid")) {
    const { code } = extractCode(descriptionRaw);
    if (code) return t("newComplaintInvalidDescription", { code });
  } else if (title.includes("New Complaint")) {
    const { code } = extractCode(descriptionRaw);

    if (code) return t("notificationNewComplaintDescription", { code });
  } else if (title.includes("Complaint to Expiration")) {
    const { code } = extractCode(descriptionRaw);
    if (code) return t("complaintToExpirationDescription", { code });
  }

  // fallback para texto original
  return descriptionRaw;
}
